import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const StyledSelect = styled(Select)`
   min-width: 261px;
` as typeof Select;
